import React, { useEffect, useState } from "react";
import { SelectInputComponent } from "../../../common/components";
import { CREATED_TIME_OPTIONS } from "../../leads/lead-filter/lead-filter.constant";
import CustomDateRangePicker from "../../leads/lead-filter/lead-filter-options/custom-date-picket";
import dayjs, { Dayjs } from "dayjs";
import { calculateDateRange } from "../../../utils/filtersUtil";
import "../../leads/lead-filter/lead-filter-options/./filter-options-select.scss"

interface CreatedOnFilterProps {
  value: string;
  onChange: (value: string) => void;
  isCreatedOnEnabled?: boolean;
  onDateRangeChange: (fromDate: Date | null, toDate: Date | null) => void;
  createdOnError?: string;
  createdOnStartError?: string;
  createdOnEndError?: string;
  setCreatedOnFromDate: (date: Dayjs | null) => void;
  setCreatedOnToDate: (date: Dayjs | null) => void;
  fromDate?: Dayjs | null;
  toDate?: Dayjs | null;
}

const CreatedOnFilter: React.FC<CreatedOnFilterProps> = ({
  value,
  onChange,
  isCreatedOnEnabled,
  onDateRangeChange,
  createdOnError,
  createdOnStartError,
  createdOnEndError,
  setCreatedOnFromDate,
  setCreatedOnToDate,
  fromDate,
  toDate
}) => {
  const [showCustomDate, setShowCustomDate] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);

  const handleOpen = () => {
    setSelectOpen(true)
  }
  const handleBlur = () => {
    setSelectOpen(false)
  }
  useEffect(() => {
    const selected = typeof value === "object" ? "" : value;
    setShowCustomDate(value.includes("Custom"));

    if (selected && selected !== "Custom") {
      const { from, to } = calculateDateRange(selected);
      onDateRangeChange(from ? from.toDate() : null, to ? to.toDate() : null);
    }
  }, [value]);

  const handleCustomRangeChange = (from: Dayjs | null, to: Dayjs | null) => {
    onDateRangeChange(from?.toDate() || null, to?.toDate() || null);
  };
  if (!isCreatedOnEnabled) return null;


  return (
    <div className="filter-select-input-wrapper" >
      <SelectInputComponent
        fieldName="createdTime"
        options={CREATED_TIME_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder=" Select Created On"
        //multiple={true}
        isFilter={true}
        selectOpen={selectOpen}
        handleOpen={handleOpen}
        handleBlur={handleBlur}
      />
      {createdOnError && <div className="error-text">{createdOnError}</div>}
      {showCustomDate && (
        <div>
          <CustomDateRangePicker
            fromDate={fromDate}
            toDate={toDate}
            onDateRangeChange={handleCustomRangeChange}
            startDateError={createdOnStartError}
            endDateError={createdOnEndError}
            setFromDate={setCreatedOnFromDate}
            setToDate={setCreatedOnToDate}
          />
        </div>
      )}
    </div>
  );
};

export default CreatedOnFilter;
